import { TdProps } from '@oaknorth/component-core-v2';

export const horizontalPinningProps: Partial<TdProps> = {
  position: 'sticky',
  left: 0,
  zIndex: 'sticky',
  background: 'white',
  css: {
    '[data-table-scroll-horizontal] &': {
      boxShadow: 'pinnedLeft',
    },
  },
};
